import React, { useState, useEffect } from "react";
import {
    Box,
    Grid2,
    Typography,
    Tabs,
    Tab,
    Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { BasicLayout } from '../../layouts/BasicLayout';
import SearchFilter from '../../components/common/SearchFilter';
import { ReactComponent as UnAssigned } from "../../assets/logos/unassigned.svg";
import { ReactComponent as Assigned } from "../../assets/logos/assigned.svg";
import { ReactComponent as Delivered } from "../../assets/logos/delivered.svg";
import { ReactComponent as Intransit } from "../../assets/logos/in-transit.svg";
import { ReactComponent as UnAssignedActive } from "../../assets/logos/unassigned_active.svg";
import { ReactComponent as AssignedActive } from "../../assets/logos/assigned_active.svg";
import { ReactComponent as DeliveredActive } from "../../assets/logos/delivered_active.svg";
import { ReactComponent as IntransitActive } from "../../assets/logos/in-transit_active.svg";
import { deliveryTabOptions, mobUserDeliveryTabOptions } from '../../data/PackageListing';
import PackageListingTable from "../../components/PackageListing/PackageListingTable";
import { getStorageValue } from "../../utils/helper";
import { useNavigate, useLocation } from "react-router-dom";
import UserListAPI from '../../utils/services/userList.api';
import NotificationsListAPI from "../../utils/services/notifications.api";

function CustomTabPanel(props) {
    const { children, value, index } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  }

function MyDeliveryPage(){
    const getTabValue = () => {
        if(getStorageValue("roleId") === "1") {
            return location?.state?.status - 2;
        } else {
            return location?.state?.status - 1;
        }
    }
    const location = useLocation();
    const [tabValue, setTabValue] = useState(
        location?.state?.status ? getTabValue() : getStorageValue("DeliveryTabs") ? Number(getStorageValue("DeliveryTabs")) : 0
    );    
    const [countData, setCountData] = useState({});
    const [isShowNotifications, setShowNotifications] = useState(false);
    const adminUsericonList = [<Assigned />, <Intransit />, <Delivered />];
    const adminUseractiveIconList = [<AssignedActive />, <IntransitActive />, <DeliveredActive />];
    const normalUsericonList = [<UnAssigned />,<Assigned />, <Intransit />, <Delivered />];
    const normalUseractiveIconList = [<UnAssignedActive />,<AssignedActive />, <IntransitActive />, <DeliveredActive />];

    const iconList = getStorageValue("roleId") === "1" ? adminUsericonList : normalUsericonList;
    const activeIconList = getStorageValue("roleId") === "1" ? adminUseractiveIconList : normalUseractiveIconList;
    
    const userId = getStorageValue("userId");
    const navigate = useNavigate();
    const { getUserDeliveryListingCount} = UserListAPI;
    const { checkUnreadNotifications } = NotificationsListAPI;
    const CurrentLatitude = getStorageValue("latitude");
    const tabOptions = getStorageValue("roleId") === "1" ? deliveryTabOptions : mobUserDeliveryTabOptions;

    // API Call to get Table data Count
    const getListingDataCount = async () => {
        const response = await getUserDeliveryListingCount(userId);
        if (response.status === "success") {
            if(getStorageValue("roleId") === "1") {
                setCountData([
                    response.data.assigned,
                    response.data.intransit,
                    response.data.delivered
                ])
            } else {
                setCountData([
                    response.data.unassigned,
                    response.data.assigned,
                    response.data.intransit,
                    response.data.delivered
                ])
            }
        }
    };

    const handleVisibilityChange = async () => {
        if (document.visibilityState === 'visible') {
          const checkDate = new Date()?.toISOString();
            const response = await checkUnreadNotifications(userId, checkDate);
            if(response?.data?.message) {
              localStorage.removeItem("isClicked");
              localStorage.setItem("isReload", response?.data?.message);
              localStorage.setItem("notifications", response?.data?.message);
              setShowNotifications(response?.data?.message);
            }
        } 
    };
    
    useEffect(() => {
        getListingDataCount();
          document.addEventListener('visibilitychange', handleVisibilityChange);
      
          return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
          };
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        getListingDataCount();
        // eslint-disable-next-line
    }, [tabValue]);

    useEffect(() => {
        if(location?.state?.status) {
            localStorage.setItem("DeliveryTabs", getStorageValue("roleId") === "1" ? location?.state?.status - 2 : location?.state?.status - 1);
        }
    }, [location])

    const handleDeleteSuccess = () => {
        getListingDataCount();
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        localStorage.setItem("DeliveryTabs", newValue);
    };

    return (
        <BasicLayout isShowNotifications={isShowNotifications}>
            <Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="h5" fontWeight={500} fontSize={24}>
                    My Delivery
                </Typography>
                <Button
                    style={{ textTransform: "none", backgroundColor: "#0C68F4"  }}
                    variant="contained"
                    size="medium"
                    startIcon={<AddIcon />}
                    onClick={() => {
                        navigate("/create-package", {state: {backURL: "/MyDelivery", status: tabValue + 2}});
                    }}
                >
                    Create New
                </Button>
                </Box>
            </Box>
            <Grid2>
                <Box sx={{ width: "100%" }}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <Tabs value={tabValue} onChange={handleTabChange} className="tab-img">
                            {tabOptions.map((ele, idx) => {
                                return (
                                    <Tab
                                    sx={{ textTransform: "none", fontSize: "13px", paddingBottom: "0px", minHeight: '50px' }}
                                    iconPosition="start"
                                    icon={
                                        idx === tabValue ? activeIconList[idx] : iconList[idx]
                                    }
                                    label={
                                        <p>
                                        <span style={{ color: idx === tabValue ? "black" : '#7C8DB5' }}> {ele} </span> (
                                        <span style={{ fontWeight: "500px" }}>
                                            {countData[idx] !== undefined ? countData[idx] : 0}
                                        </span>
                                        )
                                        </p>
                                    }
                                    />
                                );
                            })}
                        </Tabs>
                    </Box>
                    {
                        getStorageValue("roleId") === "1" ? (
                            deliveryTabOptions.map((ele, idx) => {
                                return (
                                    <CustomTabPanel key={ele + "Id"} value={tabValue} index={idx}>
                                        <SearchFilter
                                            childComponent={
                                                <PackageListingTable acceptedBy={userId} type={idx+2} 
                                                    onDeleteSuccess={handleDeleteSuccess} originPage="MyDelivery" />
                                            }
                                            filterCondition={true}
                                            typeId={idx+2}
                                            searchPage="package"
                                            defaultValue="1"
                                            defaultFilterValue="All"
                                        />
                                    </CustomTabPanel>
                                );
                                })
                        ) : (
                            mobUserDeliveryTabOptions.map((ele, idx) => {
                                return (
                                    <CustomTabPanel key={ele + "Id"} value={tabValue} index={idx}>
                                        <SearchFilter
                                            childComponent={
                                                <PackageListingTable acceptedBy={userId} type={idx+1} 
                                                    onDeleteSuccess={handleDeleteSuccess} originPage="MyDelivery" />
                                            }
                                            filterCondition={true}
                                            typeId={idx+1}
                                            searchPage="package"
                                            defaultValue="1"
                                            defaultFilterValue={CurrentLatitude ? "250" : "All"}
                                        />
                                    </CustomTabPanel>
                                );
                            })
                        )
                    }
                </Box>
            </Grid2>
        </BasicLayout>
    )
};

export default MyDeliveryPage;